<template>
  <div
    class="overflow-visible h-[5rem] bg-surface-0 dark:bg-surface-900 flex px-2 border-t-[--p-content-border-color] border-t-[1px] w-max min-w-full"
  >
    <div
      v-for="(graphObj, index) in queryStore.joinStack.data"
      :key="index"
      class="query-container flex flex-col content-center justify-center relative min-w-fit"
    >
      <CytoGraphNode
        v-model="queryStore.joinStack.data[index]"
        :suffix-needed="queryStore.suffixNeeded(graphObj)"
      ></CytoGraphNode>
    </div>
  </div>
</template>

<script setup>
import { useQueryStore } from "@/stores/queryStore.js";
import CytoGraphNode from "@/components/cyto_graph_components/CytoGraphNode.vue";

const queryStore = useQueryStore();
</script>

<style scoped lang="scss">
.query-container:first-of-type {
  & :deep(.line-left) {
    display: none;
  }
}

.query-container:last-of-type {
  & :deep(.line-right) {
    display: none;
  }
}
</style>
